<!-- 
/**
 * Progress bar component.
 * 
 * @since 2.0.0
 * @author Fahri Rusliyadi <fahri.rusliyadi@gmail.com>
 */
-->

<template>
    <transition v-on:leave="leave">
        <div v-if="active" class="progress fixed-top rounded-0 bg-transparent" style="height: 4px">
            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" v-bind:style="{ width: `${progress}%` }" v-bind:aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    </transition>
</template>

<script>
    const anime = require('anime');

    export default {
        /**
         * Properties.
         * 
         * @since 2.0.0
         * @type {Function}
         */
        data: () => ({
            /**
             * Active state.
             * 
             * Progress bar is displayed when true.
             * 
             * @since 2.0.0
             * @type {Boolean}
             */
            active: false,

            /**
             * Progress percentage.
             * 
             * @since 2.0.0
             * @type {Number}
             */
            progress: 0
        }),

        /**
         * Property watchers.
         * 
         * @since 2.0.0
         */
        watch: {
            /**
             * `active` property watcher.
             * 
             * @since 2.0.0
             * @param {Boolean} active
             */
            active: function(active) {
                if (active) {
                    this.progress = 0;
                }

                this.animation = anime({
                    targets: this.$data,
                    progress: 100,
                    easing: 'linear',
                    duration: performance.timing.responseStart - performance.timing.requestStart
                });
            }
        },

        /**
         * Methods.
         * 
         * @since 2.0.0
         * @type {Object}
         */
        methods: {
            /**
             * Leave event handler.
             * 
             * @since 2.0.0
             * @param {HTMLElement} el
             * @param {Function} done Callback after animation finished.
             */
            leave: function(el, done) {
                this.animation.seek(this.animation.duration);
                // Wait for Bootstrap transition.
                setTimeout(done, 600);
            }
        }
    }
</script>